
import { request } from "../constants/request";
import { API } from "../constants";

/**
 * A reusable function for making API calls.
 * 
 * @param {string} url - The API endpoint.
 * @param {string} method - The HTTP method (GET, POST, PUT, DELETE, etc.).
 * @param {object} [payload] - The request payload (optional for GET/DELETE).
 * @param {object} [headers] - Additional headers (optional).
 * @returns {Promise<object>} - The response from the API.
 */
const getCountry = async (url, method, payload = {}, headers = {}) => {
  return request({
    url: `${API.baseUrl}${url}`,
    method: method,
    ...(method === "POST" && { data: payload }),
  });
};
const getRestaurants = async (url, method, payload = '', headers = {}) => {
  const queryString = payload 
  ? `?filter[country_id][is]=${payload}` 
  : '';
  return request({
    url: `${API.baseUrl}${url}${queryString}`,
    method: "GET",
    });
};
const createRestaurant = async (url, method, payload = {}, headers = {}) => {
  return request({
    url: `${API.baseUrl}${url}`,
    method: method,
    data: payload, 
  });
};
const getRestaurant = async (url, method, payload = {}, headers = {}) => {
  return request({
    url: `${API.baseUrl}${url}`,
    method: method,
    data: payload, 
    headers: {
      ...headers,
      'Content-Type': 'multipart/form-data', 
    },
  });
};
const checkIsCountryExists = async (url, method, payload = {}, headers = {}) => {
  return request({
    url: `${API.baseUrl}${url}`,
    method: "POST",
    data: payload, 
   
  });
};
const deleteRestaurant = async (url, method, payload = {}, headers = {}) => {
  return request({
    url: `${API.baseUrl}${url}`,
    method: method,
    data: payload, 
   
  });
};

export  {getCountry, getRestaurants, createRestaurant, checkIsCountryExists, getRestaurant, deleteRestaurant};